import CustomersEntity from '@/entities/api/customers/customers'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface CustomersSlice {
	customers: CustomersEntity[]
	selectCustomer: CustomersEntity | null
}

const initialState: CustomersSlice = {
	customers: [],
	selectCustomer: null,
}

const customersSlice = createSlice({
	name: 'customers',
	initialState,
	reducers: {
		setCustomersFn: (state, action: PayloadAction<CustomersEntity[]>) => {
			state.customers = action.payload
		},
		setSelectCustomerFn: (state, action: PayloadAction<CustomersEntity>) => {
			state.selectCustomer = action.payload
		},
		addCustomerFn: (state, action: PayloadAction<CustomersEntity>) => {
			state.customers.push(action.payload)
		},
		updateCustomerFn: (state, action: PayloadAction<CustomersEntity>) => {
			const index = state.customers.findIndex(
				(customer) => customer._id === action.payload._id
			)
			if (index !== -1) {
				state.customers[index] = action.payload
			}
		},
		deleteCustomerFn: (state, action: PayloadAction<string>) => {
			state.customers = state.customers.filter(
				(customer) => customer._id !== action.payload
			)
		},
	},
})

export const {
	setCustomersFn,
	setSelectCustomerFn,
	addCustomerFn,
	updateCustomerFn,
	deleteCustomerFn,
} = customersSlice.actions

export default customersSlice.reducer
